/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeletePrescription$Params {
  prescriptionNumber: string;
  treatmentId: string;
  isTaps?: boolean;
  isIsabv?: boolean;
}

export function deletePrescription(http: HttpClient, rootUrl: string, params: DeletePrescription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deletePrescription.PATH, 'delete');
  if (params) {
    rb.path('prescriptionNumber', params.prescriptionNumber, {});
    rb.query('treatmentId', params.treatmentId, {});
    rb.query('isTaps', params.isTaps, {});
    rb.query('isIsabv', params.isIsabv, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deletePrescription.PATH = '/api/prescriptions/{prescriptionNumber}';
